export default {
      id: "LTC-usage",
      viewBox: "0 0 183.5 226.8",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#LTC",
      toString: function () {
        return this.url;
      }
    }